import classNames from 'classnames';
import { LinkVariant } from '../../enums';
import styles from './Link.module.scss';
export function useLinkClassName({ variant, hasIcon = false }) {
    const isGrey = variant === LinkVariant.Grey || variant === LinkVariant.GreyQuiet;
    const isBrandQuiet = variant === LinkVariant.BrandQuiet;
    const classList = {
        [styles.link]: true,
        [styles.brand]: variant === LinkVariant.Brand || isBrandQuiet,
        [styles.quiet]: variant === LinkVariant.GreyQuiet || isBrandQuiet,
        [styles.grey]: isGrey,
        [styles.brandCancel]: variant === LinkVariant.BrandCancel,
        'd-inline-flex': hasIcon,
    };
    return classNames(classList);
}
